import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';

import '@polymer/paper-styles/shadow.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-checkbox/paper-checkbox.js';
import '@polymer/iron-list/iron-list.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/av-icons.js';
import '@polymer/iron-icons/hardware-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '@katapult/pmp-simple-date-input/pmp-simple-date-input.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/paper-item/paper-icon-item.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '@polymer/paper-spinner/paper-spinner-lite.js';
import { KatapultGeometry } from 'katapult-toolbox';
import '../katapult-auth/katapult-auth.js';
import '../pole-application-sign-up-form/pole-application-sign-up-form.js';
import '../katapult-maps-desktop/katapult-tool-panel.js';
import '../paper-table/paper-table.js';
import '../bind-path/bind-path.js';
import '../login-chip/login-chip.js';
import '../user-chip/user-chip.js';
import '../hash-bind/hash-bind.js';
import '../highlight-text/highlight-text.js';
import '../input-element/input-element.js';
import '../katapult-toolbar/katapult-toolbar.js';
import { CamelCase } from '../../modules/CamelCase.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../pole-application/pole-application-style.js';
import '../style-modules/paper-table-style.js';
import { GeoFire } from 'geofire';
import '../katapult-maps-desktop/print-tools/print-generator';
import '../katapult-elements/katapult-button.js';
import { getPoleLookup } from '../pole-application/pole-application-functions.js';
import { PplTagLocation } from '../../modules/PplTagLocation.js';
import { getPortalDirectoryId } from '../../modules/PortalLocationDirectory.js';
import './attachment-record-table.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';

/*global k, Polymer, firebase*/
class PoleLookupPage extends KatapultPageElement {
  static get template() {
    return html`
      <style include="pole-application-style paper-dialog-style paper-tooltip-style paper-menu-button-style paper-table-style">
        :host {
          height: 100%;
          font-family: Roboto;
        }
        [hidden] {
          display: none !important;
        }
        #authContentWrapper {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        #contentWrapper {
          min-height: 0;
          height: 100%;
          overflow: auto;
          padding: 12px;
          background: var(--paper-grey-50);
        }
        .poleResult {
          margin: 12px;
        }
        #searchFilterContainer {
          width: 400px;
          border-radius: 4px;
          transition: all 0.3s;
          background-color: white;
          z-index: 1;
          align-self: flex-start;
        }
        #searchFilterContainer[opened=''] {
          @apply --shadow-elevation-4dp;
        }
        #searchFilterContainer > iron-collapse {
          border-top: 1px solid var(--paper-grey-200);
        }
        #searchContainer {
          display: flex;
          justify-content: center;
          align-items: center;
          width: inherit;
          padding: 4px;
          box-sizing: border-box;
        }
        #searchContainer > paper-input {
          flex-grow: 1;
        }
        #searchContainer > iron-icon {
          margin: 8px;
        }
        #contentWrapper > paper-table {
          margin: 12px;
        }
        .attacher {
          margin-left: 20px;
        }
        .poleTag {
          font-size: 16pt;
          font-weight: bold;
        }
        .poleContents {
          margin: 10px 20px;
          display: flex;
        }
        .photos {
          margin-left: 20px;
        }
        .loading {
          display: flex;
          align-items: center;
        }
        .photo {
          position: relative;
        }
        .poleImage {
          flex-direction: column;
          padding: 8px;
          font-weight: lighter;
          font-size: 10pt;
          color: var(--primary-text-color-faded);
        }
        .poleImage:hover {
          background: var(--paper-grey-50);
        }
        .poleImage[selected] {
          background: var(--paper-grey-100);
        }
        .poleImage > * {
          margin: 4px;
        }
        .poleImage > img {
          height: 64px;
          width: 64px;
          object-fit: cover;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 4px;
        }
        .poleLink {
          display: inline-block;
          text-decoration: none;
          text-align: center;
          margin: 5px;
        }
        .appLink {
          position: absolute;
          left: 0;
          top: 138px;
          background: white;
        }
        a {
          color: var(--secondary-color);
        }
        #contentWrapper a {
          text-decoration: none;
          color: inherit;
        }
        .photoStatus {
          margin-right: 10px;
          font-size: 14pt;
          color: grey;
        }
        paper-spinner-lite {
          --paper-spinner-color: var(--secondary-color);
        }
        .poleInfo paper-cell:first-of-type:not(:last-of-type) {
          font-weight: bold;
          max-width: 180px;
        }
        .photoFormContainer {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .svgContainer {
          min-height: 80vh;
          max-height: 90vh;
          height: 100%;
        }
      </style>
      <paper-toast id="toast"></paper-toast>

      <hash-bind id="hashBind" prop1="{{searchString}}"></hash-bind>
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        user-record="{{userRecord}}"
        can-read="{{userCanRead}}"
        can-write="{{userCanWrite}}"
        email="{{loginEmailBox}}"
        signed-in="{{signedIn}}"
        admin="{{admin}}"
        root-company="{{rootCompany}}"
        system-admin="{{systemAdmin}}"
        title="[[config.firebaseData.name]] Pole Applications"
        no-signup="[[!config.firebaseData.offerLicenses]]"
      >
        <katapult-firebase-worker
          id="isReviewContractor"
          path="photoheight/company_space/[[config.firebaseData.utilityCompany]]/portal_config/user_options/review_contractors/[[userGroup]]"
          data="{{isReviewContractor}}"
          disabled$="[[!signedIn]]"
        ></katapult-firebase-worker>
        <katapult-firebase-worker
          id="companyAttacherList"
          path="photoheight/company_space/[[userGroup]]/attacher_list"
          data="{{companyAttacherList}}"
          disabled$="[[!signedIn]]"
        ></katapult-firebase-worker>
        <div slot="title-content">
          <template is="dom-if" if="[[equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]">
            <p style="margin: 0;">PPL Pole Attachments Portal</p>
          </template>
          <template is="dom-if" if="[[!equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]">
            <p style="margin: 0;">[[config.firebaseData.name]]</p>
            <p style="margin: 0;">Pole Applications</p>
          </template>
        </div>
        <div slot="description-content">
          <template is="dom-if" if="[[equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]">
            <p>
              For information about the new interface, check out our
              <a href$="[[gettingStartedUrl]]" style="color: white; font-weight: normal; text-decoration: none;">Getting Started</a> guide
            </p>
            <p>
              If you have questions or need support, please call us at 717-430-0910 or email us at
              <a style="color: white; font-weight: normal; text-decoration: none;" href="mailto:support@katapultengineering.com"
                >support@katapultengineering.com</a
              >
            </p>
          </template>
          <template is="dom-if" if="[[!equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]">
            <p>[[config.firebaseData.name]] Pole Applications allows you to see your submitted and draft applications in one place.</p>
            <p>Submitting an attachment application is now paper-free and easier than ever!</p>
            <template is="dom-if" if="{{!appNameContains(config.firebaseData.name, 'katapult')}}">
              <p>
                First time here? View our
                <a href$="[[gettingStartedUrl]]" style="color: white; font-weight: normal; text-decoration: none;">Getting Started</a> guide
              </p>
            </template>
          </template>
        </div>

        <pole-application-sign-up-form
          slot="sign-up-form"
          config="[[config]]"
          email="{{loginEmailBox}}"
          attachers="{{attachers}}"
        ></pole-application-sign-up-form>

        <div id="authContentWrapper" slot="auth-content">
          <!-- This is a list that only affects display. The rules actually back up what data can be loaded -->
          <katapult-firebase-worker path="photoheight/pole_lookup_full_view/[[userGroup]]" data="{{fullView}}"></katapult-firebase-worker>
          <print-generator
            id="printGenerator"
            user-group="{{userGroup}}"
            job-name="{{jobName}}"
            job-creator="{{jobCreator}}"
            model-config="[[modelConfig]]"
            use-metric-units="[[useMetricUnits]]"
            reload-photo-function="{{reloadPhotoFunction}}"
          ></print-generator>

          <katapult-toolbar
            simple-help="[[equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]"
            user-group="[[userGroup]]"
            hide-camera-info
          >
            <!-- Left Content -->
            <div style="flex-grow: 1;" slot="left"></div>

            <div style="flex-grow: 1;" slot="left"></div>
            <!-- Center Content -->
            <div id="searchFilterContainer" slot="center" opened$="[[showFilterOptions]]" on-click="stopPropagation">
              <div id="searchContainer">
                <iron-icon icon="search"></iron-icon>
                <paper-input
                  id="searchInput"
                  label="[[config.firebaseData.name]] Pole Lookup"
                  value="{{searchString}}"
                  no-label-float=""
                  on-keypress="keyPress"
                ></paper-input>
              </div>
            </div>
            <katapult-button slot="center" style="margin: 0 10px;" loading="[[loading]]" on-click="search" color="var(--secondary-color)"
              >Search</katapult-button
            >
            <template is="dom-if" if="[[results.length]]">
              <katapult-button slot="center" id="export" icon="trending_up" iconOnly noBorder on-click="exportToCSV"></katapult-button>
              <paper-tooltip slot="center" for="export">Export To CSV</paper-tooltip>
            </template>
            <div style="flex-grow: 1;" slot="right"></div>
          </katapult-toolbar>

          <div id="contentWrapper">
            <template is="dom-if" if="[[!results.length]]">
              <div style="display: flex; justify-content: center; padding: 48px;">
                <div id="searchInfo">
                  <div>Use this search to find:</div>
                  <ul>
                    <li>General [[config.firebaseData.name]] pole data</li>
                    <template is="dom-if" if="[[or(fullView, _isReviewContractor)]]">
                      <li>Lists of attachers on record</li>
                    </template>
                    <li>Pole photos</li>
                    <li>Records of previous data collection</li>
                    <li>A link to the pole's location on Google Maps</li>
                  </ul>
                </div>
              </div>
            </template>
            <template is="dom-repeat" items="[[results]]">
              <paper-table class="poleResult" style="overflow: hidden;" rounded outline white>
                <paper-row secondary-color top-rounded class="poleTag">
                  <paper-cell>
                    <span>[[item.tag]]</span>
                    <template is="dom-if" if="[[isFirstItem(item.$isClosest, item.$isClosestCollected)]]">
                      <span>&nbsp;(Closest)</span>
                    </template>
                    <template is="dom-if" if="[[and(item.$isClosest, item.$isClosestCollected)]]">
                      <span>&nbsp;(Closest & Closest Collected)</span>
                    </template>
                    <template is="dom-if" if="[[isFirstItem(item.$isClosestCollected, item.$isClosest)]]">
                      <span>&nbsp;(Closest Collected)</span>
                    </template>
                    <template is="dom-if" if="[[item.$isEstimated]]">
                      <span>&nbsp;(Estimated Location)</span>
                    </template>
                  </paper-cell>
                  <paper-cell></paper-cell>
                </paper-row>
                <paper-row expand style="align-items: stretch;">
                  <paper-table class="poleInfo" style="border-right: 1px solid var(--paper-grey-200); flex-grow: 1;" alternating grey>
                    <paper-row micro>
                      <paper-cell title="Attachment records from Katapult Pro portal">Attachment Records</paper-cell>
                      <paper-cell></paper-cell>
                    </paper-row>
                    <paper-row expand>
                      <paper-cell>
                        <template is="dom-if" if="[[enabledFeatures.live_attachment_records]]">
                          <attachment-record-table
                            utility-company="[[config.firebaseData.utilityCompany]]"
                            search-pole-id="[[item.$companyLookupId]]"
                            has-access-to-all-records="[[fullView]]"
                            company-attacher-list="[[companyAttacherList]]"
                          ></attachment-record-table>
                        </template>
                      </paper-cell>
                    </paper-row>
                    <template is="dom-if" if="[[item.attachments.length]]">
                      <paper-row micro>
                        <paper-cell style="max-width: unset;" title="Attacher records from utility-supplied data"
                          >Attachers on Record (Legacy)</paper-cell
                        >
                        <paper-cell></paper-cell>
                      </paper-row>
                      <template is="dom-repeat" items="[[item.attachments]]">
                        <paper-row micro>
                          <paper-cell style="flex-basis: unset; flex-grow: unset; padding-right: 0;">•</paper-cell>
                          <paper-cell>[[item.order]] - [[item.name]] ([[item.agreement_number]] - [[item.attach_type]])</paper-cell>
                        </paper-row>
                      </template>
                    </template>
                    <template is="dom-if" if="[[item.latitude]]">
                      <paper-row micro>
                        <paper-cell>Location</paper-cell>
                        <paper-cell>[[item.latitude]], [[item.longitude]]</paper-cell>
                        <paper-cell id="openInGoogleMapsButton" icon-button>
                          <a href="https://www.google.com/maps/place/[[item.latitude]],[[item.longitude]]" target="_blank">
                            <katapult-button icon="open_in_new" iconOnly noBorder color="var(--paper-grey-200)"></katapult-button>
                          </a>
                        </paper-cell>
                        <paper-tooltip style="white-space: nowrap;" for="openInGoogleMapsButton" position="right"
                          >Open in Google Maps</paper-tooltip
                        >
                      </paper-row>
                    </template>
                    <template is="dom-repeat" items="[[item.properties]]">
                      <paper-row micro$="[[!greaterThan(item.$val.length, 100)]]">
                        <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                        <paper-cell>[[item.$val]]</paper-cell>
                      </paper-row>
                    </template>
                  </paper-table>
                  <template is="dom-if" if="[[item.photos.length]]">
                    <paper-table style="border-right: 1px solid var(--paper-grey-200);" dividers>
                      <paper-table-scroll>
                        <!-- <paper-row slot="before" header grey style="text-align: center;">
                        <paper-cell>Photos</paper-cell>
                      </paper-row> -->

                        <template is="dom-repeat" items="[[item.photos]]" as="photo">
                          <paper-row expand slot="before">
                            <paper-cell
                              pointer
                              class="poleImage"
                              selected$="[[equal(item.$selectedPhoto.photoId, photo.photoId)]]"
                              on-click="clickedPoleImage"
                            >
                              <img src="[[photo.photo_path]]" on-error="imageLoadError" />
                              <div>[[photo.jobName]]</div>
                              <div>[[photo.collection_date]]</div>
                              <a href="[[photo.url]]" target="_blank">
                                <katapult-button style="align-self: stretch;" size="16" color="white" on-click="stopPropagation"
                                  >Open Map</katapult-button
                                >
                              </a>
                              <template is="dom-if" if="[[photo.app_url]]">
                                <a href="[[photo.app_url]]" target="_blank">
                                  <katapult-button style="align-self: stretch;" size="16" color="white" on-click="stopPropagation"
                                    >Open Pole Application</katapult-button
                                  >
                                </a>
                              </template>
                            </paper-cell>
                          </paper-row>
                          <!-- <div class="photo">
                          <a href="[[photo.url]]" target="_blank" class="poleLink">
                            <template is="dom-if" if="[[photo.loading]]">
                              <div style="height: 162px; display: flex; justify-content: center; align-items: center;">
                                <paper-spinner-lite active></paper-spinner-lite>
                              </div>
                            </template>
                            <template is="dom-if" if="[[!photo.loading]]">
                              <img class="poleImage" src="[[photo.photo_path]]" on-error="imageLoadError"/>
                            </template>
                            <div>[[photo.jobName]]</div>
                            <div>[[photo.collection_date]]</div>
                          </a>
                          <template is="dom-if" if="[[photo.app_url]]">
                            <a href="[[photo.app_url]]" target="_blank" class="poleLink appLink">
                              <iron-icon icon="assignment" title="Application View"></iron-icon>
                            </a>
                          </template>
                        </div> -->
                        </template>
                      </paper-table-scroll>
                    </paper-table>
                    <div id$="photoForm[[item.key]]" class="photoFormContainer" style="flex-grow: 1; background: var(--paper-grey-50);">
                      <div
                        style="position: absolute; height: 100%; width: 100%; display: flex; justify-content: center; align-items: center;"
                      >
                        <paper-spinner-lite active="[[item.$loadingPhotoForm]]"></paper-spinner-lite>
                      </div>
                      <div class="svgContainer"></div>
                      <template is="dom-if" if="[[!item.$loadingPhotoForm]]">
                        <template is="dom-if" if="[[!item.$hasPhotoForm]]">
                          <span>No Photo Form</span>
                        </template>
                      </template>
                    </div>
                  </template>
                </paper-row>
              </paper-table>
            </template>
          </div>
        </div>
      </katapult-auth>
    `;
  }

  static get is() {
    return 'pole-lookup-page';
  }
  static get properties() {
    return {
      searchString: {
        type: String,
        value: ''
      },
      results: {
        type: Array,
        value: () => []
      },
      rootCompany: {
        type: String,
        value: null
      },
      isReviewContractor: {
        type: Boolean,
        value: false
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      }
    };
  }
  static get observers() {
    return [];
  }
  connectedCallback() {
    super.connectedCallback();
    this.shpFileRisersOnMapListener = addFlagListener('live_attachment_records', (enabled) => {
      this.set('enabledFeatures.live_attachment_records', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    removeFlagListener('live_attachment_records', this.shpFileRisersOnMapListener);
  }
  ready() {
    super.ready();
    if (window.location.search) {
      this.searchString = window.location.search.slice(1);
    }
    this.appConfiguration = new AppConfiguration(this, {
      dataLoaded: () => {
        this.search();
      }
    });
  }
  and(a, b) {
    return a && b;
  }
  or(a, b) {
    return a || b;
  }
  isFirstItem(a, b) {
    return a && !b;
  }
  equal(a, b) {
    return a == b;
  }
  greaterThan(a, b) {
    return a > b;
  }
  keyPress(e) {
    if (e.keyCode == 13) this.search();
  }

  _isReviewContractor() {
    return this.userGroup == this.config?.firebaseData?.utilityCompany || this.isReviewContractor;
  }

  async search() {
    this.loading = true;
    this.results = [];
    var tagList = this.searchString.toUpperCase();
    if (tagList != '') {
      tagList = tagList.split(/[ ,;]+/);
      for (let i = 0; i < tagList.length; i++) {
        let poleTag = tagList[i];
        // If it is a lat/long, find the closest pole on record
        if (!isNaN(poleTag) && !isNaN(tagList[i + 1])) {
          // Find closest PPL record
          let latitude = Number(poleTag);
          let longitude = Number(tagList[++i]);
          let ref = firebase
            .app()
            .database(`https://${this.config.firebaseData.contextLayers.poles.database}.firebaseio.com`)
            .ref(this.config.firebaseData.contextLayers.poles.url);
          await this.findClosest(latitude, longitude, ref);
          // Find closest collected pole
          const portalDirectoryId = await getPortalDirectoryId(this.userGroup, this.config.firebaseData.utilityCompany);
          if (portalDirectoryId) {
            let firestoreRef = firebase.firestore().collection(`companies/${this.userGroup}/directories/${portalDirectoryId}/locations`);
            await this.findClosest(latitude, longitude, firestoreRef, true);
          }
        } else {
          // Get pole lookup data if we didn't just get it from lat/long
          const record = await getPoleLookup({ poleTag });
          await this.addResult(record);
        }
      }
    } else {
      this.$.searchInput.focus();
    }
    this.loading = false;
  }

  async findClosest(latitude, longitude, ref, masterLocationDirectory) {
    let closestPoles = await new GeoFire(ref).once({ radius: 0.3048, center: [latitude, longitude] });
    let closest = { pole: null, distance: Infinity };
    for (let poleId in closestPoles) {
      let distance = KatapultGeometry.CalcDistance(latitude, longitude, ...closestPoles[poleId].l);
      if (closest.distance > distance) {
        closest = { pole: closestPoles[poleId], distance };
      }
    }
    if (closest.pole) {
      if (masterLocationDirectory) {
        let jobIds = closest.pole?.d?.j || [];
        let tagsFound = {};
        for (let jobId of jobIds) {
          let nodes = await FirebaseWorker.ref(`photoheight/jobs/${jobId}/nodes`)
            .once('value')
            .then((s) => s.val());
          let closestNode = { pole: null, distance: Infinity };
          for (let nodeId in nodes) {
            let tags = nodes[nodeId].attributes?.pole_tag;
            for (let tagId in tags) {
              if (tags[tagId].company == 'PPL' || tags[tagId].company == 'PPL Company') {
                let distance = KatapultGeometry.CalcDistance(latitude, longitude, nodes[nodeId].latitude, nodes[nodeId].longitude);
                if (closestNode.distance > distance) {
                  closestNode = { nodeId, node: nodes[nodeId], distance, tag: tags[tagId].tagtext };
                }
                break;
              }
            }
          }
          if (closestNode.tag) {
            if (!tagsFound[closestNode.tag]) {
              tagsFound[closestNode.tag] = true;
              //See if we already found this same pole
              let existingClosest = this.results.findIndex((x) => x.$isClosest && x.tag == closestNode.tag);
              if (existingClosest != -1) {
                this.set(`results.${existingClosest}.$isClosestCollected`, true);
              } else {
                let record = await getPoleLookup({ poleTag: closestNode.tag });
                record.data.$isClosestCollected = true;
                await this.addResult({ key: closestNode.tag, data: record.data });
              }
            }
          }
        }
      } else {
        let poleTag = closest.pole.info.tag;
        closest.pole.$isClosest = true;
        await this.addResult({ key: poleTag, data: closest.pole });
      }
    }
  }

  async addResult(record) {
    const poleTag = record.key;
    const result = record.data;

    const tagText = result.info?.tag ?? poleTag;

    // Get attachments (if we have permission)
    let attachments = [];
    if (this.fullView || this._isReviewContractor()) {
      try {
        const attachers = await firebase
          .app()
          .database(`https://${this.config.firebaseData.contextLayers.poles.database}.firebaseio.com`)
          .ref(this.config.firebaseData.contextLayers.poles.url.replace('poles', 'attachments') + '/' + poleTag)
          .once('value')
          .then((s) => s.val());

        for (let id in attachers) {
          if (id.startsWith('id_')) {
            let agreement_number = id.replace('id_', '');
            attachers[id].forEach((att) => {
              att.agreement_number = agreement_number;
              attachments.push(att);
            });
          }
        }
      } catch (e) {
        //normal error, no access to attachers
      }
    }

    // Get survey data (photos)
    let photos = [];
    let lookupTextKeys = [];
    switch (this.config.firebaseData.utilityCompany) {
      case 'ppl_attachments':
        lookupTextKeys.push('PPL Company');
        break;
      case 'lge':
        lookupTextKeys.push('KU', 'LGE');
        break;
      case 'rie':
        lookupTextKeys.push('Rhode Island Energy');
        break;
      case 'UGI_utilities':
        lookupTextKeys.push('UGI');
        break;
      case 'KCI_technologies_inc':
        lookupTextKeys.push('KCI');
        break;
      case 'burns_&_McDonnell':
        // TODO: add keys for utility companies
        break;
    }

    const lookup = { jobs: {} };
    for (const key of lookupTextKeys) {
      let lookupData = await FirebaseWorker.ref(`photoheight/pole_lookup/${key}/${poleTag}`)
        .once('value')
        .then((s) => s.val());

      if (!lookupData)
        lookupData = await FirebaseWorker.ref(`photoheight/pole_lookup/${key}/${result.info?.tag}`)
          .once('value')
          .then((s) => s.val());

      for (const jobId in lookupData?.jobs) {
        lookup.jobs[jobId] = lookupData.jobs[jobId];
      }
    }

    for (const jobId in lookup.jobs) {
      try {
        let name = await FirebaseWorker.ref(`photoheight/jobs/${jobId}/name`)
          .once('value')
          .then((s) => s.val());
        let jobCreator = await FirebaseWorker.ref(`photoheight/jobs/${jobId}/job_creator`)
          .once('value')
          .then((s) => s.val());
        for (const nodeId in lookup.jobs[jobId].nodes) {
          if (lookup.jobs[jobId].nodes[nodeId].photoId != null) {
            let app_url = null;
            if (name.includes('APP_')) {
              let appId = jobId;
              if (name.includes('Survey')) {
                appId = await FirebaseWorker.ref(`photoheight/job_permissions/${this.userGroup}/jobs`)
                  .orderByChild('name')
                  .equalTo(name.replace('Survey', '').trim())
                  .once('value')
                  .then((s) => Object.keys(s.val() || {})[0]);
              }
              if (appId) {
                app_url = `https://ppl.katapultwebservices.com/pole-application/#${appId}`;
              }
            }
            photos.push({
              photoId: lookup.jobs[jobId].nodes[nodeId].photoId,
              jobId,
              nodeId,
              jobCreator,
              url: `https://ppl.katapultwebservices.com/map/#${jobId}/n${nodeId}`,
              collection_date: this.formatDate(lookup.jobs[jobId].nodes[nodeId].date_taken),
              photo_path: await this.getPhotoPath(jobId, lookup.jobs[jobId].nodes[nodeId].photoId),
              jobName: name,
              app_url
            });
          }
        }
      } catch (e) {
        //normal error, no access to job
      }
    }
    //Convert Objects to descriptions
    if (result) {
      delete result.info.tag;
      for (let key in result.info) {
        let item = result.info[key];
        if (
          (!this.fullView || !this._isReviewContractor()) &&
          !['pole_class', 'pole_height', 'pole_owner', 'class', 'height', 'owner'].includes(key)
        ) {
          delete result.info[key];
        } else if (typeof item === 'object') {
          let string = '';
          for (let subkey in item) {
            if (string != '') string += '; ';
            if (key == 'Transformer') string += item[subkey].labeltext || 'No Transformer Size Available';
            else if (key == 'Capacitor') {
              string +=
                `a:${item[subkey].a_phase_si} b:${item[subkey].b_phase_si} c:${item[subkey].c_phase_si}` || 'No Capacitor Size Available';
            } else if (key == 'Recloser' || key == 'Switch') string += item[subkey].device_des || 'No Description Available';
            else if (key == 'Streetlight') {
              for (let prop in item[subkey]) {
                string += `${CamelCase(prop)} - ${item[subkey][prop]}; `;
              }
            } else if (item[subkey].device_des) string += item[subkey].device_des;
            else if (item[subkey].device_descr) string += item[subkey].device_descr;
            else {
              string += JSON.stringify(item[subkey], null, 4);
            }
          }
          result.info[key] = string;
        }
      }
    }
    if (!result) {
      let location = PplTagLocation(poleTag);
      if (location) {
        result = {
          l: [location.latitude, location.longitude],
          info: {},
          $isEstimated: true
        };
      }
    }
    this.push('results', {
      $companyLookupId: tagText,
      key: FirebaseWorker.ref().push().key,
      tag: `${tagText} ${result ? '' : '- (Pole Not Found)'} ${photos.length ? '' : '- (No Photos)'}`,
      attachments,
      latitude: result.l?.[0],
      longitude: result.l?.[1],
      properties: Object.entries(result.info ?? {}).map(([key, value]) => ({ $key: key, $val: value })),
      info: result.info ?? {},
      photos,
      $selectedPhoto: photos.length ? photos[0] : null,
      $photoStatus: photos.length == 0 ? 'none' : 'received',
      $isClosest: result.$isClosest ?? false,
      $isClosestCollected: result.$isClosestCollected ?? false,
      $isEstimated: result.$isEstimated ?? false
    });
  }

  async getPhotoPath(jobId, photoId) {
    if (photoId[0] == '-') {
      return FirebaseWorker.ref(`photoheight/jobs/${jobId}/photos/${photoId}/url_small`)
        .once('value')
        .then((s) => s.val());
    } else {
      return firebase
        .storage()
        .ref('photos/' + photoId + '_small.webp')
        .getDownloadURL();
    }
  }

  async imageLoadError(e) {
    let photo = e.model.photo;
    let index = e.model.index;
    let itemsIndex = e.model.itemsIndex;
    if (photo.photoId[0] == '-') {
      this.set(`results.${itemsIndex}.photos.${index}.loading`, true);
      let res = await firebase.functions().httpsCallable('signS3JobPhotos')({ jobId: photo.jobId, photos: { [photo.photoId]: true } });
      this.set(
        `results.${itemsIndex}.photos.${index}.photo_path`,
        await FirebaseWorker.ref(`photoheight/jobs/${photo.jobId}/photos/${photo.photoId}/url_small`)
          .once('value')
          .then((s) => s.val())
      );
      this.set(`results.${itemsIndex}.photos.${index}.loading`, false);
    }
  }

  formatDate(time) {
    let date = new Date(time * 1000);
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }
  camelCase(text) {
    return CamelCase(text);
  }
  clickedPoleImage(e) {
    e.model.set('item.$selectedPhoto', e.model.get('photo'));
  }
  exportToCSV() {
    let csv = '';
    let headers = [
      'pole tag',
      'latitude',
      'longitude',
      'map link',
      'collection date(s)',
      'collection job(s}',
      'collection link(s)',
      'application link(s)'
    ];
    let infoHeaders = [];
    if (this.fullView || this._isReviewContractor()) {
      headers.push('Attachers on Record');
    }
    this.results.forEach((result) => {
      csv += result.tag + ',';
      csv += result.latitude + ',';
      csv += result.longitude + ',';
      csv += `"https://www.google.com/maps/place/${result.latitude},${result.longitude}",`;
      let dates = '';
      let jobNames = '';
      let links = '';
      let appLinks = '';
      result.photos.forEach((photo) => {
        dates += (dates != '' ? '\n' : '') + (photo.collection_date || '');
        jobNames += (jobNames != '' ? '\n' : '') + (photo.jobName || '');
        links += (links != '' ? '\n' : '') + (photo.url || '');
        appLinks += (appLinks != '' ? '\n' : '') + (photo.app_url || '');
      });
      csv += `"${dates}","${jobNames}","${links}","${appLinks}",`;
      if (this.fullView || this._isReviewContractor()) {
        csv += '"';
        result.attachments.forEach((item, i) => {
          if (i > 0) csv += '\n';
          csv += `${item.order} - ${item.name} (${item.agreement_number} - ${item.attach_type})`;
        });
        csv += '",';
      }

      result.properties.forEach((property) => {
        if (!infoHeaders.includes(property.$key)) {
          infoHeaders.push(property.$key);
        }
      });
      if (result.$isEstimated && !infoHeaders.includes('estimated_location')) {
        infoHeaders.push('estimated_location');
      }
      infoHeaders.forEach((header) => {
        if (header == 'estimated_location') {
          csv += (result.$isEstimated || '') + ',';
        } else {
          csv += '"' + ((result.info[header] || '') + '').replace(/[,"]/g, '') + '",';
        }
      });
      csv += '\n';
    });
    csv = headers.concat(infoHeaders).join(',') + '\n' + csv;
    let link = document.createElement('a');
    link.href = URL.createObjectURL(
      new Blob([csv], {
        type: 'text/csv'
      })
    );
    link.download = 'Pole Lookup Export.csv';
    link.click();
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
}
window.customElements.define(PoleLookupPage.is, PoleLookupPage);
